module.exports = __webpack_public_path__ + "img/logo-amica.019e6b2c.png";